import React, { ChangeEvent, useState } from 'react'
import {
  Checkbox,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogOverlay,
  AlertDialogHeader,
  Button
} from '@apex/component-library'
import { Stack, Text, Link, HStack, Box } from '@chakra-ui/react'

export interface TermsOfUseProps {
  isChecked: boolean
  onChange: (event: ChangeEvent) => void
}

export const TermsOfUse = ({ isChecked, onChange }: TermsOfUseProps) => {
  const [showMoreInfo, setShowMoreInfo] = useState(false)
  const [showTermsOfUse, setShowTermsOfUse] = useState(false)

  const cancelRef = React.useRef<HTMLButtonElement>(null)

  const handleTermsOfUseClick = () => setShowTermsOfUse(true)

  const handleShowMoreInfo = () => setShowMoreInfo(true)

  const handleAlertClose = () => {
    setShowTermsOfUse(false)
    setShowMoreInfo(false)
  }

  return (
    <>
      <Stack spacing={4}>
        <Text>
          Recipient may receive less due to fees charged by the recipient’s bank and foreign taxes. You have a right to
          dispute errors in your transaction.{' '}
          <Button onClick={handleShowMoreInfo} fontWeight='400' border='0' variant='link'>
            More Info
          </Button>
        </Text>
        <HStack spacing={1}>
          <Box paddingTop={1.5}>
            <Checkbox isChecked={isChecked} name='termsOfUse' onChange={onChange}>
              I agree to the{' '}
            </Checkbox>
          </Box>
          <Button onClick={handleTermsOfUseClick} fontWeight='400' border='0' variant='link'>
            Terms of Use
          </Button>
        </HStack>
      </Stack>

      <AlertDialog
        isCentered
        isOpen={showMoreInfo}
        leastDestructiveRef={cancelRef}
        motionPreset='slideInBottom'
        onClose={handleAlertClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Transfer Information</AlertDialogHeader>
            <AlertDialogBody>
              <Stack>
                <Text>
                  If you think there is an error, contact your broker. You can also contact your broker for a written
                  explanation of your rights. You can cancel for a full refund within 30 minutes of payment, unless the
                  funds have been picked up or deposited. For questions or complaints about your broker, contact:
                </Text>
                <Stack spacing={0}>
                  <Text>FINRA Investor Complaint Center</Text>
                  <Text>Fax: (866) 397-3290</Text>
                  <Link color='blue.400' isExternal href='http://www.finra.org/complaint/'>
                    http://www.finra.org/complaint/
                  </Link>
                </Stack>
                <Stack spacing={0}>
                  <Text>Consumer Financial Protection Bureau</Text>
                  <Text>855-411-2372</Text>
                  <Text>855-729-2372 (TTY/TDD)</Text>
                  <Link color='blue.400' isExternal href='http://www.consumerfinance.gov'>
                    http://www.consumerfinance.gov
                  </Link>
                </Stack>
              </Stack>
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button variant='outline' ref={cancelRef} onClick={handleAlertClose}>
                Close
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <AlertDialog
        isCentered
        isOpen={showTermsOfUse}
        leastDestructiveRef={cancelRef}
        motionPreset='slideInBottom'
        onClose={handleAlertClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Terms of Use</AlertDialogHeader>
            <AlertDialogBody>
              I agree to hold all parties acting on this request, including the introducing broker and Apex Clearing
              Corporation, and their respective agents and employees (hereinafter, collectively, "the parties") harmless
              from any and all claims, demands, proceedings, suits and actions and all liabilities, losses, and expenses
              including without limitation those asserted by me, associated actions taken by the parties due to
              instructions received from me in this request.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button variant='outline' ref={cancelRef} onClick={handleAlertClose}>
                Close
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
